import PropTypes from "prop-types";
import React from "react";
import { siteinfos } from "../cms/data/settings";


const Layout = ({ children, theme, raw, formObject, ...props }) => {
  raw = raw || false;
  return (
    <>
      
          {children}
         
        </>
      )}


Layout.propTypes = {
  children: PropTypes.any,
  raw: PropTypes.bool,
  theme: PropTypes.any,
  formObject: PropTypes.string
};

export default Layout;
